import { FunctionComponent } from 'react'
import { CopyableId } from '~/components/CopyableId'

/**
 * The media's id under its name, on every tab of the media's own pages. Both products' route trees point
 * at this, so the label and the tracking label are written once.
 */
export const MediaIdSubtitle: FunctionComponent<{ id: string }> = ({ id }) => (
  <span className={'flex items-center gap-1 text-xs/[20px] font-normal text-slate-grey'}>
    {/* No type of its own: size, weight and colour all inherit from the span above. */}
    <CopyableId id={id} label={'Media ID'} trackingLabel={'common-medias-id-copy'} />
  </span>
)
